import React from 'react';
import {
  ItemRenderProps,
  TreeView as KendoTreeView,
  TreeViewExpandChangeEvent,
  TreeViewItemClickEvent
} from '@progress/kendo-react-treeview';

type KendoReactTreeViewProps = {
  data: any[];
  expandIcons?: boolean;
  item?: React.ComponentType<ItemRenderProps>;
  onExpandChange?: (event: TreeViewExpandChangeEvent) => void;
  onItemClick?: (event: TreeViewItemClickEvent) => void;
};

export const KendoReactTreeView = (props: KendoReactTreeViewProps) => {
  const {
    data,
    expandIcons = false,
    item,
    onExpandChange,
    onItemClick
  } = props;

  return (
    <div className="kendo-react-tree-view">
      <link
        href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
        rel="stylesheet"
        type="text/css"
      />
      <KendoTreeView
        data={data}
        expandIcons={expandIcons}
        item={item}
        onExpandChange={onExpandChange}
        onItemClick={onItemClick}
      />
    </div>
  );
};

export type {
  ItemRenderProps,
  TreeViewExpandChangeEvent,
  TreeViewItemClickEvent
} from '@progress/kendo-react-treeview';
